import PagingColumn from "../components/PagingColumn";

export default function getSessionColumns(sessionType, compacted){
    const _columns = [];
    if (sessionType === 1) {
        _columns.push(
        new PagingColumn(
            "problem",
            true,
            false,
            "left",
            30,
            true, false,
        )
        );
    }
    _columns.push(
        new PagingColumn(
        "bookmark",
        true,
        false,
        "center",
        30,
        true, false,
        )
    );
    _columns.push(
        new PagingColumn(
        "notes",
        true,
        false,
        "left",
        30,
        true, false,
        )
    );
    _columns.push(
        new PagingColumn(
        "site",
        true,
        false,
        "center",
        compacted ? 42 : 34,
        )
    );
    _columns.push(
        new PagingColumn(
        "day_of_week",
        true,
        false,
        "right",
        90,
        true,
        true
        )
    );
    _columns.push(
        new PagingColumn(
        "date",
        true,
        false,
        "left",
        compacted ? 150 : 130,
        )
    );
    _columns.push(
        new PagingColumn(
        "category",
        true,
        false,
        "left",
        24,
        )
    );
    _columns.push(
        new PagingColumn(
        "name",
        true,
        true,
        "left",
        300,
        )
    );
    _columns.push(
        new PagingColumn(
        "time_spent",
        true,
        false,
        "left",
        75,
        true,
        true
        )
    );
    _columns.push(
        new PagingColumn(
        "nbHands",
        true,
        false,
        "center",
        75,
        true,
        true
        )
    );
    _columns.push(
        new PagingColumn(
        "game_format",
        true,
        false,
        "center",
        27,
        )
    );
    _columns.push(
        new PagingColumn(
        "game_variant",
        true,
        false,
        "center",
        27,
        true,
        true
        )
    );
    if (sessionType === 1) {
        _columns.push(
        new PagingColumn(
            "structure_type",
            true,
            false,
            "center",
            27,
            true, false
        )
        );
    }
    _columns.push(
        new PagingColumn(
        "special_type",
        true,
        false,
        "center",
        27,
        true, sessionType === 1
        )
    );

    if (sessionType === 1) {
        _columns.push(
        new PagingColumn(
            "buyin",
            true,
            false,
            "center",
            120,
        )
        );
        _columns.push(
        new PagingColumn(
            "prizepool",
            true,
            false,
            "center",
            100,
        )
        );
        _columns.push(
        new PagingColumn(
            "nbplayers",
            true,
            false,
            "center",
            70,
        )
        );
        _columns.push(
        new PagingColumn(
            "finish",
            true,
            false,
            "center",
            70,
        )
        );
        _columns.push(
        new PagingColumn(
            "gain",
            true,
            false,
            "left",
            95,
        )
        );
        _columns.push(
        new PagingColumn(
            "netgain",
            true,
            false,
            "left",
            95,
        )
        );
    } else {
        _columns.push(
        new PagingColumn(
            "limit",
            true,
            false,
            "center",
            100,
            true, true
        )
        );
        _columns.push(
        new PagingColumn(
            "rake",
            true,
            false,
            "center",
            95,
            true, false
        )
        );
        _columns.push(
        new PagingColumn(
            "netgain_vshero",
            true,
            false,
            "left",
            88,
        )
        );
        _columns.push(
        new PagingColumn(
            "netgain_ev",
            true,
            false,
            "left",
            95,
        )
        );
        _columns.push(
        new PagingColumn(
            "netgain",
            true,
            false,
            "left",
            95,
        )
        );
    }
    _columns.push(
        new PagingColumn(
        "last_hand",
        false,
        false,
        "left",
        170,
        )
    );
    return _columns;
}